module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 6);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var START_TWO_FACTOR = exports.START_TWO_FACTOR = 'START_TWO_FACTOR';
  var FINISH_TWO_FACTOR = exports.FINISH_TWO_FACTOR = 'FINISH_TWO_FACTOR';
  var CONTINUE_TWO_FACTOR = exports.CONTINUE_TWO_FACTOR = 'CONTINUE_TWO_FACTOR';
  var RESET_DESTINATIONS = exports.RESET_DESTINATIONS = 'RESET_DESTINATIONS';
  var GET_DESTINATIONS_REQUEST = exports.GET_DESTINATIONS_REQUEST = 'GET_DESTINATIONS_REQUEST';
  var GET_DESTINATIONS_FAILURE = exports.GET_DESTINATIONS_FAILURE = 'GET_DESTINATIONS_FAILURE';
  var GET_DESTINATIONS_SUCCESS = exports.GET_DESTINATIONS_SUCCESS = 'GET_DESTINATIONS_SUCCESS';
  var RESET_CHALLENGE = exports.RESET_CHALLENGE = 'RESET_CHALLENGE';
  var SEND_CHALLENGE_REQUEST = exports.SEND_CHALLENGE_REQUEST = 'SEND_CHALLENGE_REQUEST';
  var SEND_CHALLENGE_FAILURE = exports.SEND_CHALLENGE_FAILURE = 'SEND_CHALLENGE_FAILURE';
  var SEND_CHALLENGE_SUCCESS = exports.SEND_CHALLENGE_SUCCESS = 'SEND_CHALLENGE_SUCCESS';
  /***/
},
/* 1 */

/***/
function (module, exports) {
  module.exports = require("@myie/interact");
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _twoFactorActions = __webpack_require__(5);

  var twoFactorActions = _interopRequireWildcard(_twoFactorActions);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var mapDispatchToProps = _extends({}, twoFactorActions);

  exports.default = mapDispatchToProps;
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var mapStateToProps = function mapStateToProps(state) {
    var _state$twoFactorDefin = state.twoFactorDefinition,
        twoFactorDefinition = _state$twoFactorDefin === undefined ? {} : _state$twoFactorDefin;
    var inProgress = twoFactorDefinition.inProgress,
        challenge = twoFactorDefinition.challenge,
        status = twoFactorDefinition.status,
        destinations = twoFactorDefinition.destinations,
        error = twoFactorDefinition.error,
        url = twoFactorDefinition.url;
    return {
      inProgress: inProgress,
      challenge: challenge,
      status: status,
      destinations: destinations,
      error: error,
      url: url
    };
  };

  exports.default = mapStateToProps;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _twoFactorDefinition = __webpack_require__(7);

  var _twoFactorDefinition2 = _interopRequireDefault(_twoFactorDefinition);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _twoFactorDefinition2.default;
  /***/
},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.sendChallenge = exports.sendChallengeSuccess = exports.sendChallengeFailure = exports.sendChallengeRequest = exports.resetChallenge = exports.getDestinations = exports.getDestinationsSuccess = exports.getDestinationsFailure = exports.getDestinationsRequest = exports.resetDestinations = exports.finishTwoFactor = exports.continueTwoFactor = exports.startTwoFactor = undefined;

  var _interact = __webpack_require__(1);

  var _twoFactorTypes = __webpack_require__(0);

  var startTwoFactor = exports.startTwoFactor = function startTwoFactor(url, key, status) {
    return {
      type: _twoFactorTypes.START_TWO_FACTOR,
      url: url,
      status: status,
      key: key
    };
  };

  var continueTwoFactor = exports.continueTwoFactor = function continueTwoFactor(status) {
    return {
      type: _twoFactorTypes.CONTINUE_TWO_FACTOR,
      status: status
    };
  };

  var finishTwoFactor = exports.finishTwoFactor = function finishTwoFactor() {
    return {
      type: _twoFactorTypes.FINISH_TWO_FACTOR
    };
  };

  var resetDestinations = exports.resetDestinations = function resetDestinations() {
    return {
      type: _twoFactorTypes.RESET_DESTINATIONS,
      isFetching: false,
      success: false,
      error: null,
      destinations: null
    };
  };

  var getDestinationsRequest = exports.getDestinationsRequest = function getDestinationsRequest() {
    return {
      type: _twoFactorTypes.GET_DESTINATIONS_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var getDestinationsFailure = exports.getDestinationsFailure = function getDestinationsFailure(error) {
    return {
      type: _twoFactorTypes.GET_DESTINATIONS_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var getDestinationsSuccess = exports.getDestinationsSuccess = function getDestinationsSuccess(json) {
    return {
      type: _twoFactorTypes.GET_DESTINATIONS_SUCCESS,
      destinations: json,
      isFetching: false,
      error: null
    };
  };

  var getDestinations = exports.getDestinations = function getDestinations(request) {
    return function (dispatch) {
      dispatch(getDestinationsRequest());
      return fetch(_interact.Connection.baseUrl('2fa') + 'v1.0/challenge/availabledestinations', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify(request)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(getDestinationsSuccess(json));
      }).catch(function (error) {
        return dispatch(getDestinationsFailure(error));
      });
    };
  };

  var resetChallenge = exports.resetChallenge = function resetChallenge() {
    return {
      type: _twoFactorTypes.RESET_CHALLENGE,
      isFetching: false,
      success: false,
      error: null,
      challenge: null
    };
  };

  var sendChallengeRequest = exports.sendChallengeRequest = function sendChallengeRequest() {
    return {
      type: _twoFactorTypes.SEND_CHALLENGE_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var sendChallengeFailure = exports.sendChallengeFailure = function sendChallengeFailure(error) {
    return {
      type: _twoFactorTypes.SEND_CHALLENGE_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var sendChallengeSuccess = exports.sendChallengeSuccess = function sendChallengeSuccess(json) {
    return {
      type: _twoFactorTypes.SEND_CHALLENGE_SUCCESS,
      challenge: json,
      isFetching: false,
      error: null
    };
  };

  var sendChallenge = exports.sendChallenge = function sendChallenge(request) {
    return function (dispatch) {
      dispatch(sendChallengeRequest());
      return fetch(_interact.Connection.baseUrl('2fa') + 'v1.0/challenge/send', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify(request)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(sendChallengeSuccess(json));
      }).catch(function (error) {
        return dispatch(sendChallengeFailure(error));
      });
    };
  };
  /***/

},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.mapDispatchToProps = exports.mapStateToProps = exports.twoFactorDefinition = undefined;

  var _reducer = __webpack_require__(4);

  var _reducer2 = _interopRequireDefault(_reducer);

  var _mapStateToProps = __webpack_require__(3);

  var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);

  var _mapDispatchToProps = __webpack_require__(2);

  var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.twoFactorDefinition = _reducer2.default;
  exports.mapStateToProps = _mapStateToProps2.default;
  exports.mapDispatchToProps = _mapDispatchToProps2.default;
  /***/
},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _interact = __webpack_require__(1);

  var _twoFactorTypes = __webpack_require__(0);

  var twoFactorDefinition = function twoFactorDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case _twoFactorTypes.START_TWO_FACTOR:
        _interact.TwoFactor.setUrl(action.url);

        _interact.TwoFactor.setKey(action.key);

        _interact.TwoFactor.setStatus(action.status);

        return _extends({}, state, {
          url: action.url,
          key: action.key,
          status: action.status,
          inProgress: true
        });

      case _twoFactorTypes.CONTINUE_TWO_FACTOR:
        _interact.TwoFactor.setStatus(action.status);

        return _extends({}, state, {
          status: action.status,
          inProgress: true
        });

      case _twoFactorTypes.FINISH_TWO_FACTOR:
        _interact.TwoFactor.clear();

        return _extends({}, state, {
          url: null,
          key: null,
          status: null,
          inProgress: false
        });

      case _twoFactorTypes.GET_DESTINATIONS_SUCCESS:
        return _extends({}, state, {
          destinations: action.destinations,
          isFetching: action.isFetching,
          error: action.error
        });

      case _twoFactorTypes.RESET_DESTINATIONS:
        return _extends({}, state, {
          success: action.success,
          isFetching: action.isFetching,
          destinations: action.destinations,
          error: action.error
        });

      case _twoFactorTypes.GET_DESTINATIONS_FAILURE:
      case _twoFactorTypes.GET_DESTINATIONS_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          success: action.success,
          error: action.error,
          destinations: null
        });

      case _twoFactorTypes.SEND_CHALLENGE_SUCCESS:
        return _extends({}, state, {
          challenge: action.challenge,
          isFetching: action.isFetching,
          error: action.error
        });

      case _twoFactorTypes.RESET_CHALLENGE:
        _interact.TwoFactor.setStatus('ISSUED');

        return _extends({}, state, {
          status: 'ISSUED',
          success: action.success,
          isFetching: action.isFetching,
          challenge: action.challenge,
          error: action.error
        });

      case _twoFactorTypes.SEND_CHALLENGE_FAILURE:
      case _twoFactorTypes.SEND_CHALLENGE_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          success: action.success,
          error: action.error,
          challenge: null
        });

      default:
        return state;
    }
  };

  exports.default = twoFactorDefinition;
  /***/
}
/******/
]);